import api from "./api";
import { HomePage } from "../shared/home-page-models";

export const getHomePageData = async (): Promise<HomePage> => {
  const response = await api.get<HomePage>(
    "/web/v1/home-page-information?include=last9Posts"
  );
  return response.data;
};
